import { render } from "./pairing-batch-show-table.vue?vue&type=template&id=4f9b7016&lang=pug"
import script from "./pairing-batch-show-table.vue?vue&type=script&setup=true&lang=js"
export * from "./pairing-batch-show-table.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__